import { Rect } from '../../drawing';
import { ChantContext } from '../../gregorio-chant/ChantContext';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';
import { VisualizerHelper } from '../visualizers/VisualizerHelper';

export class DivisioFinalis extends ChantLayoutElement {

  constructor(context: ChantContext) {
    super(context);
  }

  public performLayout(prevElements: ChantLayoutElement[]): void {
    const prev = VisualizerHelper.findLastGlyphOrSpaceOrBarOrSign(prevElements);
    let x = 0;
    if (prev) {
      x = prev.bounds.right;
    }
    // +1 for second line width
    this.bounds = Rect.create(
      x, 0, this._distanceConverter.lengthToPx(this._context.divisiofinalissep) + 2, 
      this._context.staffLinesInterval * 6); 
  }

  public createSvgFragments(): SVGElement[] {
    const element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    element.setAttribute('class', 'DivisioFinalis');
    element.setAttribute('transform', `translate(${this.bounds.x}, ${this.bounds.y})`);


    const line1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line1.setAttribute('x1', String(this.bounds.x));
    line1.setAttribute('y1', String(this.bounds.y));
    line1.setAttribute('x2', String(this.bounds.x));
    line1.setAttribute('y2', String(this.bounds.bottom));
    line1.setAttribute('stroke', '#000000');
    line1.setAttribute('stroke-width', '1');

    const secondLineX = this.bounds.x + this._distanceConverter.lengthToPx(this._context.divisiofinalissep);
    const line2 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line2.setAttribute('x1', String(secondLineX));
    line2.setAttribute('y1', String(this.bounds.y));
    line2.setAttribute('x2', String(secondLineX));
    line2.setAttribute('y2', String(this.bounds.bottom));
    line2.setAttribute('stroke', '#000000');
    line2.setAttribute('stroke-width', '1');

    element.appendChild(line1);
    element.appendChild(line2);

    return [
      ...super.createSvgFragments(),
      element,
    ];
  }
}
